import { Component, inject, type OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { AuthService } from '@auth/repository';
import { NotifyComponent } from '@core/components/notify/notify.component';
import { getBrowser } from '@helpers/browser';
import { DownloadProgressToastComponent } from '@shared/widgets/download-progress-toast/download-progress-toast.component';

@Component({
  selector: 'ume-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [RouterOutlet, NotifyComponent, DownloadProgressToastComponent],
})
export class AppComponent implements OnInit {
  // private matIconRegistry: MatIconRegistry = inject(MatIconRegistry);
  private readonly authService: AuthService = inject(AuthService);

  constructor() {
    // Set the default font set for all mat-icon instances
    // this.matIconRegistry.setDefaultFontSetClass('material-symbols-outlined');

    document.body.classList.add(getBrowser());
  }

  ngOnInit(): void {
    this.authService.initApp();
  }
}
